import React from 'react';
import { Typography } from '@mui/material';
import { red } from '@mui/material/colors';
import { droneDeliveryDurationMinutes } from '../../../utils/date-utils';

interface OverdueTimerProps {
  expectedDeliveryDate?: string;
}

const OverdueTimer = ({ expectedDeliveryDate }: OverdueTimerProps) => {
  const [now, setNow] = React.useState<number>(Date.now());

  React.useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  if (!expectedDeliveryDate) return null;

  try {
    const oneMinInMs = 60000;
    const droneMs = (droneDeliveryDurationMinutes || 0) * 60 * 1000;
    const takeoffTime = new Date(expectedDeliveryDate).getTime() - droneMs;
    const isOverDue = takeoffTime < now;

    // Mirror DueIn: only render when overdue
    if (!isOverDue) return null;

    const delta = now - takeoffTime; // positive ms overdue
    const mins = Math.floor(delta / oneMinInMs);
    const secs = Math.floor((delta / 1000) % 60).toString().padStart(2, '0');

    const value = `${mins} Mins`;
    return (
      <div style={{ marginTop: 8, marginBottom: 8 }}>
        <Typography variant="body2" color="textSecondary">Overdue by</Typography>
        <Typography variant="body1" sx={{ color: red[500], fontWeight: 400 }}>{value}</Typography>
      </div>
    );
  } catch (_e) {
    return null;
  }
};

export default OverdueTimer;
